import { render } from "./index.vue?vue&type=template&id=991b0432&scoped=true&bindings={\"color\":\"props\",\"dark\":\"props\",\"withBorder\":\"props\",\"hover\":\"props\",\"selected\":\"props\",\"round\":\"props\",\"colorStyle\":\"options\",\"bgStyle\":\"options\"}"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=991b0432&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-991b0432"

export default script